import {CostBreakdownName, ServiceLevel} from '@yandex-taxi/js-integration-api'
import {useEstimateState} from '@yandex-taxi/react-integration-api'
import {useStoreContext} from '@yandex-taxi/react-integration-api/build/module/components/Context'
import {setZonePoint} from '@yandex-taxi/react-integration-api/build/module/store/state/zone/actions'
import {getZonePoint} from '@yandex-taxi/react-integration-api/build/module/store/state/zone/selectors'
import {useCallback} from 'react'

// временное решение
// @yandex-taxi/react-integration-api пока не поддерживает обновление способов оплаты без смены зоны
// поэтому для того чтобы их обновить, нужно обновить координату зоны
// по сути координата та же самая, главное чтобы ссылка обновилась
// ----
// по мимо способов оптаты обновится еще zoneinfo и все что завязано на координате зоны, но это нормально
export const UNSTABLE__useZonePointUpdate = () => {
  const [state, dispatch] = useStoreContext()
  const zonePoint = getZonePoint(state)

  return useCallback(() => {
    if (zonePoint) {
      dispatch(
        setZonePoint({
          point: [...zonePoint],
        }),
      )
    }
  }, [dispatch, zonePoint])
}

type ExtendedServiceLevel = ServiceLevel & {
  is_fixed_price: boolean
  title?: string
}

export const useEstimateFareDisclaimer = (tariff: string): boolean => {
  const data = useEstimateState().data
  const serviceLevel = data?.service_levels?.filter(level => level.class === tariff)[0] as ExtendedServiceLevel

  return !!serviceLevel?.fare_disclaimer
}

export const useEstimateTitle = (defaultTitle: string, tariff: string, withLabel: boolean): string => {
  const data = useEstimateState().data
  const serviceLevel = data?.service_levels?.filter(level => level.class === tariff)[0] as ExtendedServiceLevel
  const text = data?.currency_rules.text
  const sign = data?.currency_rules.sign

  if (serviceLevel) {
    const detailPrice = serviceLevel.details_tariff.find(detail => detail.type === 'price')?.value
    const displayCost = serviceLevel.cost_message_details.cost_breakdown?.find(
      costBreakdown => costBreakdown.display_name === CostBreakdownName.COST,
    )?.display_amount
    const price: string | undefined = serviceLevel.is_fixed_price ? serviceLevel.price : undefined
    const finalPrice: string | undefined = (price || displayCost || detailPrice).replace(text, sign)
    const title = serviceLevel.title || defaultTitle

    return withLabel ? [title, finalPrice].filter(Boolean).join('・') : finalPrice
  }

  return defaultTitle
}
